import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44bfe07c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "two-column" }
const _hoisted_2 = { class: "column column-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "column-form-wrapper column" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "inputs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "side-img",
        src: require('@/assets/' + _ctx.imageFileName),
        alt: _ctx.altText
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.BankInfoFormConfiguration.title), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_MultiSelect, {
          placeholder: "Nome do Banco",
          options: _ctx.banksListSum,
          modelValue: _ctx.formInfo.bankName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formInfo.bankName) = $event)),
          "allow-empty": false,
          isInvalid: _ctx.inputIsInvalid.bankName,
          errors: _ctx.inputsErrors.bankName
        }, null, 8, ["options", "modelValue", "isInvalid", "errors"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BankInfoFormConfiguration.formInputsInfo, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_FormTextInput, {
            name: item.name,
            key: index,
            type: item.type,
            placeholder: item.placeholder,
            isInvalid: _ctx.inputIsInvalid[item.name],
            errors: _ctx.inputsErrors[item.name],
            modelValue: _ctx.formInfo[item.name],
            "onUpdate:modelValue": ($event: any) => ((_ctx.formInfo[item.name]) = $event),
            class: ""
          }, null, 8, ["name", "type", "placeholder", "isInvalid", "errors", "modelValue", "onUpdate:modelValue"])), [
            [_directive_maska, item.mask]
          ])
        }), 128))
      ]),
      _createVNode(_component_ButtonDefault, {
        id: "btn-bank-info-submit",
        msg: _ctx.BankInfoFormConfiguration.submittLabel,
        onButtonClicked: _ctx.handleSubmit
      }, null, 8, ["msg", "onButtonClicked"])
    ])
  ]))
}